import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
// import ApiService from "@/core/services/api.service";
// import MockService from "@/core/mock/mock.service";
import { VERIFY_AUTH } from "@/core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";

Vue.config.productionTip = false;
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
Vue.component("loading", Loading);
Vue.component("vuetable-pagination", VuetablePagination);
Vue.component("vuetable", Vuetable);
import VModal from "vue-js-modal";
Vue.use(VModal);
import Notifications from "vue-notification";
Vue.use(Notifications);
// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;
import { ToggleButton } from "vue-js-toggle-button";

Vue.component("ToggleButton", ToggleButton);

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
Vue.component("multiselect", Multiselect);

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
// import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";

// API service init
// ApiService.init();

// Remove this to disable mock API
// MockService.init();
console.log(process.env);
router.beforeEach((to, from, next) => {
  // Ensure we checked auth before each page load.
  Promise.all([store.dispatch(RESET_LAYOUT_CONFIG)]).then(next);

  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

import Toasted from "vue-toasted";
Vue.use(Toasted, {
  duration: 3000,
  position: "top-right",
});

import Toaster from "./components/Toaster";
Vue.use(Toaster);

new Vue({
  router,
  store,
  i18n,
  // vuetify,
  render: (h) => h(App),
}).$mount("#app");
